export default __webpack_public_path__ + "static/media/select-duration.590cc594.png";